export default __webpack_public_path__ + "static/twitter_square-9d2741f7fc114c6fe65cff8f88889844.png";